import {ProviderData} from '@shared/interfaces';
import {Actions, ofActionSuccessful, Store} from '@ngxs/store';
import {AnalyticsService} from '@app/service/util/analytics.service';
import {ANALYTICS_COMPONENT} from '@shared/analytics';
import {AuthState} from '@shared/state/auth/auth.state';
import {AnonLogin, LoginFailure, LoginSuccess} from '@shared/state/auth/auth.actions';
import {take} from 'rxjs/operators';

export const isOwner = (userRole: string): boolean => {
  return userRole && ['owner', 'superuser'].includes(userRole);
};

export const isAnon = (providerId: string): boolean => {
  return providerId && ['anonymous', 'superuser'].includes(providerId.toLowerCase());
};

export const hasProviderId = (providerData: ProviderData[], id: string): boolean => {
  if (!providerData) {
    return false;
  }
  for (const provider of providerData) {
    if (provider.providerId === id) {
      return true;
    }
  }
  return false;
};

export const autoAuthUser = (store: Store, actions: Actions, analytics: AnalyticsService,
                             analyticsComponent: ANALYTICS_COMPONENT) => {
  const isAuth = store.selectSnapshot(AuthState.getUserID);

  // If the user is already authenticated either by anon or regular, stop here
  if (isAuth) {
    return;
  }

  store.dispatch(new AnonLogin());

  // After AnonLogin is dispatched, LoginSuccess will get fired, so we should check for the success of this Action
  actions.pipe(ofActionSuccessful(LoginSuccess))
    .pipe(take(1))
    .subscribe(async () => {
      if (analytics && analyticsComponent) {
        analytics.trackMissionCritical(analyticsComponent, 'anon-login', 'create', 'success');
      }
    });
  actions.pipe(ofActionSuccessful(LoginFailure))
    .pipe(take(1))
    .subscribe(async () => {
      if (analytics && analyticsComponent) {
        analytics.trackMissionCritical(analyticsComponent, 'anon-login', 'create', 'error', {
          dataSnapshot: store.snapshot()
        });
      }
    });
};
